import React, { useState, useEffect, useCallback } from 'react';
import { Menu, X, ShoppingCart, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = ({ cartCount, onCartClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black shadow-lg shadow-red-900/20' : 'bg-black/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_menu-delicioso-2/artifacts/o8djjetr_ChatGPT%20Image%2016%20dic%202025%2C%2013_36_57.png"
              alt="Mr. Crunch 28"
              className="h-16 w-16 object-contain rounded-full"
            />
            <div className="text-xl md:text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">
              Mr. Crunch 28
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-gray-300 hover:text-orange-500 font-medium transition-colors"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="text-gray-300 hover:text-orange-500 font-medium transition-colors"
            >
              Menú
            </button>
            <button
              onClick={() => scrollToSection('sobre-nosotros')}
              className="text-gray-300 hover:text-orange-500 font-medium transition-colors"
            >
              Sobre Nosotros
            </button>
            <button
              onClick={() => scrollToSection('vip')}
              className="text-gray-300 hover:text-orange-500 font-medium transition-colors flex items-center"
            >
              <span className="text-yellow-500 mr-1">👑</span> VIP
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-gray-300 hover:text-orange-500 font-medium transition-colors"
            >
              Contacto
            </button>
          </nav>

          {/* Actions */}
          <div className="flex items-center space-x-2 md:space-x-4">
            <Button
              variant="ghost"
              size="icon"
              className="relative text-white hover:bg-red-900/20"
              onClick={onCartClick}
            >
              <ShoppingCart className="h-5 w-5" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Button>
            <Button 
              className="hidden md:flex bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 shadow-lg shadow-red-900/50"
              onClick={() => window.open('https://wa.me/528771228589', '_blank')}
            >
              <Phone className="h-4 w-4 mr-2" />
              WhatsApp
            </Button>
            <button
              className="md:hidden text-white"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('inicio')}
                className="text-gray-300 hover:text-orange-500 font-medium transition-colors text-left"
              >
                Inicio
              </button>
              <button
                onClick={() => scrollToSection('menu')}
                className="text-gray-300 hover:text-orange-500 font-medium transition-colors text-left"
              >
                Menú
              </button>
              <button
                onClick={() => scrollToSection('sobre-nosotros')}
                className="text-gray-300 hover:text-orange-500 font-medium transition-colors text-left"
              >
                Sobre Nosotros
              </button>
              <button
                onClick={() => scrollToSection('vip')}
                className="text-gray-300 hover:text-orange-500 font-medium transition-colors text-left"
              >
                👑 VIP
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="text-gray-300 hover:text-orange-500 font-medium transition-colors text-left"
              >
                Contacto
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
